import React from "react";
import { Player, PostDetails, SocialMentionData } from "@/services/bedrock";
import { PostScheduledStatus } from "@/interfaces";
import { SocialMentionSearch, AbstractPlayer } from "@/components";

interface MentionsSectionProps {
  post: PostDetails;
  player?: Player;
  mentions: SocialMentionData[];
  onAddMention: (mention: SocialMentionData) => void;
  onRemoveMention: (mention: SocialMentionData) => void;
}

export function UpdateMentionsSection({ post, player, mentions, onAddMention, onRemoveMention }: MentionsSectionProps) {
  const abstractPlayer: AbstractPlayer | undefined = React.useMemo(() => {
    if (!player) return undefined;
    return {
      userId: player.userId,
      playerId: player.id,
      name: player.fullName,
      photoUrl: player.photoUrl,
    } as AbstractPlayer;
  }, [player]);

  return (
    <div className="py-2">
      <SocialMentionSearch
        players={abstractPlayer ? [abstractPlayer] : undefined}
        mentions={mentions}
        onAddMention={onAddMention}
        onRemoveMention={onRemoveMention}
        isPosted={post.scheduledStatus === PostScheduledStatus.POSTED}
        networksFilter={post?.postSocialNetworks?.map(sn => sn.socialNetworkId)}
      />
    </div>
  );
}
